import { render, staticRenderFns } from "./declares.vue?vue&type=template&id=39d8cd8e"
import script from "./declares.vue?vue&type=script&lang=js"
export * from "./declares.vue?vue&type=script&lang=js"
import style0 from "./declares.vue?vue&type=style&index=0&id=39d8cd8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports